import { GetterTree } from "vuex"
import { RootState } from "../../index"
import { State } from "./state"
import { NotificationBanner, TypeEmailFrequency } from "./types"

export type Getters = {
    getNotificationBanner(state: State): NotificationBanner
    getIsHelpCenter(state: State): boolean
    getResellerStatus(state: State): boolean
    getResellerManageWorkspaceStatus(state: State): boolean
    getResellerTotalCredits(state: State): number
    getResellerViewUsageStatus(state: State): boolean
    getLinkToResellerSubscriptionStatus(state: State): boolean
    getDefaultReseller(state: State): boolean
    getLanguageList(state: State): Array<object>
    getDefaultLanguage(state: State): string
    getLanguageData(state: State): Object
    getPaidUser(state: State): boolean
    getMobileReminderStatus(state: State): {
        count: number
        showReminderAt: string | null
    }
    getProfileData(state: State): boolean
    getCandidateListStatus(state: State): boolean
    getIsCandidateDelete(state: State): boolean
    getUnreadNotificationCount(state: State): number
    getADAcompliance(state: State): boolean
    getSessionId(state: State): string
    getDrawerValue(state: State): boolean
    getCompanyTestDrawerValue(state: State): boolean
    getResellerName(state: State): string
    getDenyCreateWorkspace(state: State): boolean
    getVisibleTableHeadingsList(state: State): Array<string>
    getCheckListFilter(state: State): Array<string>
    getSortDetails(state: State): object
    getADPFilterDetails(state: State): object
    getALPFilterDetails(state: State): object
    getALPCheckListFilter(state: State): Array<string>
    getALPVisibleTableHeadingsList(state: State): Array<string>
    getCLPFilterDetails(state: State): object
    getTLPFilterDetails(state: State): object
    getTEMPLPFilterDetails(state: State): object
    getTalentFilterDetails(state: State): object
    getQLPFilterDetails(state: State): object
    getUserFilterDetails(state: State): object
    getAssTestTabFilterDetails(state: State): object
    getAssQueTabFilterDetails(state: State): object
    getCompanyQueTabFilterDetails(state: State): object
    getResellerDomain(state: State): string
    getisResellerActive(state: State): boolean
    getAccessToken(state: State): string
    getCurrentUserCountryDialCode(state: State): string
    getCurrentUserTimezone(state: State): string
    isSupportLogin(state: State): boolean
    getDiscoverPercentage(state: State): number
    getSAMLSSOEnabledFlag(state: State): boolean
    getIsValidCard(state: State): boolean
    getEmailReminderFrequency(state: State): TypeEmailFrequency
    getSubscriptionInactiveModal(state: State): boolean
    getEmployerUrl(state: State): string
    hideIfAHMReseller(state: State): boolean
    getResellerAnalytics(state: State): boolean
}

export const getters: GetterTree<State, RootState> & Getters = {
    getNotificationBanner(state) {
        return state.notificationBanner
    },
    getResellerStatus(state) {
        return state.isReseller
    },
    getResellerManageWorkspaceStatus(state) {
        return state.manageWorkspace
    },
    getResellerTotalCredits(state) {
        return state.resellerTotalCredits
    },
    getResellerViewUsageStatus(state) {
        return state.resellerViewUsage
    },
    getLinkToResellerSubscriptionStatus(state) {
        return state.linkToResellerSubscriptionStatus
    },
    getDefaultReseller(state) {
        return state.isDefaultReseller
    },
    getLanguageList(state) {
        return state.locale.languageList
    },
    getDefaultLanguage(state) {
        return state.locale.defaultLanguage
    },
    getLanguageData(state) {
        return state.locale.languageJson
    },
    getPaidUser(state) {
        return state.isPaidUser
    },
    getMobileReminderStatus(state) {
        return state.mobileReminderStatus
    },
    getProfileData(state) {
        return state.isProfileDataLoaded
    },
    getCandidateListStatus(state) {
        return state.isCandidateListOpen
    },
    getIsCandidateDelete(state) {
        return state.isCandidateDelete
    },
    getUnreadNotificationCount(state) {
        return state.unReadNotificationCount
    },
    getIsHelpCenter(state) {
        return state.isHelpCenter
    },
    getADAcompliance(state) {
        return state.ADAcompliance
    },
    getSessionId(state) {
        return state.sessionId
    },
    getDrawerValue(state) {
        return state.isDrawerOpen
    },
    getCompanyTestDrawerValue(state) {
        return state.isCompanyTestDrawerOpen
    },
    getResellerName(state) {
        return state.resellerName
    },
    getDenyCreateWorkspace(state) {
        return state.isDenyCreateWorkspace
    },
    getShowPlansTab(state) {
        return state.showPlansTab
    },
    getVisibleTableHeadingsList(state) {
        return state.ADPSession.visibleTableHeadings
    },
    getALPVisibleTableHeadingsList(state) {
        return state.websiteFilters.ALPVisibleTableHeadings
    },
    getCheckListFilter(state) {
        return state.ADPSession.checkListFilter
    },
    getSortDetails(state) {
        return state.ADPSession.sortDetails
    },
    getADPFilterDetails(state) {
        return state.ADPSession.filterDetails
    },
    getALPFilterDetails(state) {
        return state.websiteFilters.ALPFilterDetails
    },
    getALPCheckListFilter(state) {
        return state.websiteFilters.ALPcheckListFilter
    },
    getCLPFilterDetails(state) {
        return state.websiteFilters.CLPFilterDetails
    },
    getTLPFilterDetails(state) {
        return state.websiteFilters.TLPFilterDetails
    },
    getTEMPLPFilterDetails(state) {
        return state.websiteFilters.TEMPLPFilterDetails
    },
    getTalentFilterDetails(state) {
        return state.websiteFilters.TalentFilterDetails
    },
    getQLPFilterDetails(state) {
        return state.websiteFilters.QLPFilterDetails
    },
    getUserFilterDetails(state) {
        return state.websiteFilters.userFilterDetails
    },
    getAssTestTabFilterDetails(state) {
        return state.websiteFilters.assTestTabFilterDetails
    },
    getAssQueTabFilterDetails(state) {
        return state.websiteFilters.assQueTabFilterDetails
    },
    getCompanyQueTabFilterDetails(state) {
        return state.websiteFilters.companyQueTabFilterDetails
    },
    getResellerDomain(state) {
        return state.resellerDomain
    },
    getisResellerActive(state) {
        return state.isResellerActive
    },
    getCurrentUserCountryDialCode(state) {
        return state.currentUserCountryDialCode
            ? state.currentUserCountryDialCode
            : "91"
    },
    getCurrentUserTimezone(state) {
        return state.currentUserTimeZone
            ? state.currentUserTimeZone
            : "Asia/Kolkata"
    },
    getAccessToken(state) {
        let token =
            document.cookie
                .match(
                    "(^|;)\\s*" + "sessionAccessKeyCookie" + "\\s*=\\s*([^;]+)"
                )
                ?.pop() || ""
        return token
    },
    isSupportLogin(state) {
        return state.isSupportLogin
    },
    getDiscoverPercentage(state) {
        return state.discoverPercentage
    },
    getSAMLSSOEnabledFlag(state) {
        return state.ssosamlEnabled
    },
    getIsValidCard(state) {
        return state.isValidCard
    },
    getEmailReminderFrequency(state) {
        return state.emailReminderFrequency
    },
    getSubscriptionInactiveModal(state) {
        return state.isSubscriptionInactiveModal
    },
    getEmployerUrl(state) {
        return state.employerDomain
    },
    hideIfAHMReseller(state) {
        if (state.resellerName === "American Health Marketplace") {
            if (state.manageWorkspace) {
                return true
            }
            return false
        }
        return true
    },
    getResellerAnalytics(state) {
        return state.isResellerAnalytics
    },
}
